import classes from "./backdrop.module.css";
import ReactDOM from "react-dom";
import React from "react";
const Backdrop = ({clickHandler}) => {
  return ReactDOM.createPortal(
    <>
      <div onClick = {clickHandler} className={classes.backdrop}></div>
    </>,
    document.getElementById("right_sidebar")
  );
};
export default Backdrop;
